import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Card, CardBody, Tab, Tabs } from '@heroui/react';
import { EducationIcon } from '@components/userDocuments/editDocument/editResume/EditSpace/LeftPane/leftPaneIcons';
import breakpointsMinWidth from '@styling/breakpointsMinWidth';
import { Redirect, useHistory } from 'react-router';
import { connect } from 'react-redux';
import SSOLogin from './ssoLogin';
import SignInSignUp from './signInSignUp';
import breakpoints from '../../../styling/breakpoints';
import SVGLogo from '../../../../../common/components/UI/Toolbar/LeftToolbar/Logo/svgLogo';
import route from '../../../constants/route';
import {
  LogoContainer,
  LogoWrapper,
  MarketingContainer,
} from './institutionSignin';
import { loginTabs } from './signinSignupEnums';
import CustomButton from './components/button';
import Loader from '../loader/nextUICircularLoader';

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: 50px 1fr;
  height: 100vh;
  overflow-y: scroll;

  @media ${breakpoints.tabletSm} {
    grid-template-columns: repeat(8, 1fr);
  }
  @media ${breakpoints.mobileLg} {
    grid-template-columns: repeat(4, 1fr);
  }
  @media ${breakpoints.mobileSm} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const LoginContainer = styled.div`
  width: 100%;
`;
const SigninWrapper = styled.div`
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  margin-top: 40px;
  @media ${breakpointsMinWidth.tabletSm} {
    margin-top: 45px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    margin-top: 55px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    margin-top: 65px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin-top: 85px;
  }
`;

export const HR = styled.div`
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  margin: 0px 4px;
  @media ${breakpoints.desktopMd} {
    grid-column: 2 / span 5;
  }
  @media ${breakpoints.tabletLg} {
    grid-column: 2 / span 5;
  }
  @media ${breakpoints.tabletSm} {
    grid-column: 1 / span 7;
  }
  @media ${breakpoints.mobileSm} {
    grid-column: 1 / span 7;
  }
`;
export const Line = styled.hr`
  flex: 1 0 0%;
  height: 1px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #e7e7e7;
  opacity: 1;
`;
export const OR = styled.span`
  color: #a5a5a5;
  font-size: 16px;
  margin: 0px 6px;
`;

const StyledCard = styled(Card)`
  width: 100%;
  padding: 0 24px;
  box-shadow: none;
  max-width: 420px;

  @media ${breakpointsMinWidth.tabletSm} {
    width: 420px;
    padding: 16px;
    --tw-shadow:
      0px 0px 15px 0px rgb(0 0 0 / 0.03), 0px 2px 30px 0px rgb(0 0 0 / 0.08),
      0px 0px 1px 0px rgb(0 0 0 / 0.3);
    box-shadow:
      0 0 #0000,
      0 0 #0000,
      var(--tw-shadow);
    max-width: unset;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    width: 440px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    width: 475px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 522px;
  }
`;

const StyledCardBody = styled(CardBody)`
  padding: 0 4px !important;
`;

const tabData = [
  {
    key: loginTabs.LOGIN,
    value: loginTabs.LOGIN,
    dataTestId: 'login-tab',
  },
  {
    key: loginTabs.REGISTER,
    value: loginTabs.REGISTER,
    dataTestId: 'register-tab',
  },
];

const Signin = (props) => {
  const { activeTab, user, userInfo } = props;
  const [selectedTab, setSelectedTab] = useState(activeTab || 'Login');
  const history = useHistory();

  const [redirectPage, setRedirectPage] = useState(''); // State to manage the current page

  const defaultRedirectTo = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const signup = searchParams.get('signup');
    let path;
    if (signup) {
      path = route.APPS;
    } else {
      path =
        !localStorage.getItem('rurl') ||
        localStorage.getItem('rurl').split('/signin')[0] === ''
          ? route.APPS
          : localStorage.getItem('rurl');
    }
    return <Redirect to={{ pathname: path }} />;
  };

  useEffect(() => {
    if (user?.token) {
      if (!userInfo.userInfoFetched) {
        setRedirectPage('fetching'); // Set state to show fetching screen
      } else if (
        userInfo?.signUpQuestions &&
        userInfo?.signUpQuestions?.answers &&
        userInfo?.signUpQuestions?.answers?.isCompleted
      ) {
        setRedirectPage('default'); // Set state to default page
      } else {
        setRedirectPage('onboarding'); // Set state to onboarding
      }
    }
  }, [userInfo.userInfoFetched]);

  if (redirectPage === 'fetching') {
    return <Loader position="absolute" top="35%" />;
  }

  if (redirectPage === 'onboarding') {
    return <Redirect to="/onboarding" />;
  }

  if (redirectPage === 'default') {
    return defaultRedirectTo();
  }

  if (!user.token) {
    return (
      <Container>
        <MarketingContainer>
          <LogoContainer>
            <LogoWrapper
              onClick={() => {
                window.open(process.env.REACT_APP_REDIRECT_SIGNOUT, '_blank');
              }}
            >
              <SVGLogo
                appType="CRA"
                pathname={window.location.pathname}
                isTop
              />
            </LogoWrapper>
          </LogoContainer>
        </MarketingContainer>

        <SigninWrapper>
          <StyledCard className="h-max mb-[50px]">
            <StyledCardBody>
              <LoginContainer enabled={selectedTab}>
                {/* tabs */}
                <div className="h-[48px]">
                  <Tabs
                    aria-label="Dynamic tabs"
                    fullWidth
                    variant="bordered"
                    items={tabData}
                    className="m-[12px] desktopMd:mx-[20px]"
                    selectedKey={selectedTab}
                    onSelectionChange={setSelectedTab}
                    size="sm"
                    classNames={{
                      tabList:
                        'shadow-none border-none bg-[#f4f4f5] h-full rounded-[16px]',
                      tab: 'h-full rounded-[16px] [&>span]:rounded-[16px]',
                      base: '!m-0 !border-none [&>div]:!gap-0 h-full rounded-[16px]',
                    }}
                  >
                    {({ key, value }) => (
                      <Tab
                        key={key}
                        title={
                          <div className="flex items-center gap-[4px] text-[16px]">
                            <span data-testid={`${key}-tab`}>{value}</span>
                          </div>
                        }
                      />
                    )}
                  </Tabs>
                </div>
                <div className="flex flex-col gap-[14px] py-[16px] tabletMd:py-[16px] desktopSm:py-[20px] desktopMd:py-[24px]">
                  {/* SSO Login */}
                  <SSOLogin />

                  {/* Institution Login */}
                  {selectedTab === loginTabs.LOGIN && (
                    <CustomButton
                      startContent={<EducationIcon />}
                      onClick={() => {
                        history.push('/signin-with-institution');
                      }}
                      data-testid="signin-with-institution-link"
                      aria-label="Sign in with Institution"
                    >
                      Login with Institution
                    </CustomButton>
                  )}
                </div>
                <HR>
                  <Line />
                  <OR>OR</OR>
                  <Line />
                </HR>

                <SignInSignUp currentLabel={selectedTab} />
              </LoginContainer>
            </StyledCardBody>
          </StyledCard>
        </SigninWrapper>
      </Container>
    );
  }
  return <Loader position="absolute" top="35%" />;
};

const mapStateToProps = (state) => ({
  user: state.user,
  userInfo: state.userInfoReducer,
});
export default connect(mapStateToProps)(Signin);
